module.exports = __webpack_public_path__ + "static/media/sleigh.5e12d7f2.svg";